import { BlocksTableHeaderCell } from 'blocks-nextjs/blocks-web-components/components/table-header-cell/table-header-cell';
import React from 'react';
import { createComponent } from '../CustomWrapper/CustomWrapper';
export const CatTableHeaderCell = createComponent({
    react: React,
    tagName: 'cat-table-header-cell',
    elementClass: BlocksTableHeaderCell,
    events: {
        onBlColumnSort: 'bl-column-sort',
        onBlRowCellSelectAll: 'bl-row-cell-select-all'
    }
});
